// import React from 'react'
// import { Routes, Route } from 'react-router-dom'
// import Home from './pages/Home'
// import Collection from './pages/Collection'
// import About from './pages/About'
// import Contact from './pages/Contact'
// import Product from './pages/Product'
// import Cart from './pages/Cart'
// import Login from './pages/Login'
// import PlaceOrder from './pages/PlaceOrder'
// import Orders from './pages/Orders'
// import Navbar from './components/Navbar'
// import Footer from './components/Footer'
// import SearchBar from './components/SearchBar'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Verify from './pages/Verify'
// import Costomize from './components/Customize.jsx'
// import PasswordReset from './pages/ResetPassword.jsx'

// import Profile from './pages/Profile.jsx'
// import Privacypolicy from './pages/Privacypolicy.jsx'
// import TermsAndConditions from './pages/TermsAndCondition.jsx'
// import Career from "./pages/career.jsx"
// import ExchangeReturn from './pages/ExchangeReturn.jsx'
// import Layout from './Layout';
// import SignUp from './pages/SignUp.jsx'
// const App = () => {
//   return (
//     <div className='px-0.1 sm:px-[0.1vw] md:px-[0.1vw] lg:px-[0.1vw]'>
//       <ToastContainer />
//       <Layout>
//       <Navbar />
//       <SearchBar />
//       <Routes>
//         <Route path='/' element={<Home />} />
//         <Route path='/collection' element={<Collection />} />
//         <Route path='/about' element={<About />} />
//         <Route path='/contact' element={<Contact />} />
//         <Route path='/product/:productId' element={<Product />} />
//         <Route path='/cart' element={<Cart />} />
//         <Route path='/login' element={<Login />} />
//         <Route path='/place-order' element={<PlaceOrder />} />
//         <Route path='/orders' element={<Orders />} />
//         <Route path='/verify' element={<Verify />} />
//         <Route path='/customize' element={<Costomize/>} />
//         <Route path='/profile' element={<Profile/>} />
//         <Route path="/reset-password" element={<PasswordReset />} />
//         <Route path="/privacy-policy" element={<Privacypolicy />} />
//         <Route path="/termandc" element={<TermsAndConditions />} />
//         <Route path="/career" element={<Career/>} />
//         <Route path="/return-exchange" element={<ExchangeReturn/>} />
//         <Route path="/signup" element={<SignUp/>} />
        
//       </Routes>
//       <Footer />
//       </Layout>
//     </div>
//   )
// }

// export default App







import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Collection from './pages/Collection';
import About from './pages/About';
import Contact from './pages/Contact';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Login from './pages/Login';
import PlaceOrder from './pages/PlaceOrder';
import Orders from './pages/Orders';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SearchBar from './components/SearchBar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Verify from './pages/Verify';
// import Customize from './components/Customize.jsx';
import PasswordReset from './pages/ResetPassword.jsx';
import Profile from './pages/Profile.jsx';
import Privacypolicy from './pages/Privacypolicy.jsx';
import TermsAndConditions from './pages/TermsAndCondition.jsx';
import Career from './pages/career.jsx';
import ExchangeReturn from './pages/ExchangeReturn.jsx';
import Layout from './Layout';
import SignUp from './pages/SignUp.jsx';
import Chatbot from './pages/Chatbot.jsx';
import SiteMap from './pages/Sitemap.jsx';
import { Helmet } from 'react-helmet-async';
// import Men from './pages/Men.jsx';
import Men from './pages/Men.jsx';
import Women from './pages/Women.jsx';
import BecameaPart from './pages/BecameaPart.jsx';
import Scratch from "./pages/Scratch.jsx"
import Kids from './pages/Kids.jsx';
import Offilinestore from './pages/Offilinestore.jsx';
// import HeartRain from './components/HeartRain.jsx';
import WhatsAppButton from './components/WhatsAppButton.jsx';
import { useScrollRestoration } from "./hooks/useScrollRestoration";
import ScrollRestoration from "./ScrollRestoration";
import ScrollManager from "./ScrollManager";
import { useNavigationInfo } from "./useNavigationInfo";
const App = () => {
  const location = useLocation();
  useScrollRestoration();
  const { isBack } = useNavigationInfo();
  const currentPath = location.pathname;
  const siteUrl = "https://mammothstreetwears.com";
  
  const pageVariants = {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
  };

  const pageTransition = {
    duration: 0.5,
    ease: 'easeInOut',
  };
 
  const pageSEO = {
    "/": {
      title: "Mammoth Streetwear - Shop Trendy & Premium Streetwear",
      description: "Explore the latest streetwear trends at Mammoth Streetwear. Shop stylish hoodies, T-shirts, joggers, and accessories at the best prices.",
    },
    "/collection": {
      title: "Collections - Mammoth Streetwear",
      description: "Discover our exclusive collections of premium streetwear. Shop hoodies, T-shirts, joggers, and accessories now!",
    },
    "/about": {
      title: "About Us - Mammoth Streetwear",
      description: "Learn more about Mammoth Streetwear and our passion for premium quality streetwear fashion.",
    },
    "/contact": {
      title: "Contact Us - Mammoth Streetwear",
      description: "Get in touch with Mammoth Streetwear for inquiries, orders, and customer support.",
    },
    "/cart": {
      title: "Your Cart - Mammoth Streetwear",
      description: "Review your selected streetwear items before checkout.",
    },
    "/login": {
      title: "Login - Mammoth Streetwear",
      description: "Sign in to your Mammoth Streetwear account to manage your orders and wishlist.",
    },
    "/signup": {
      title: "Sign Up - Mammoth Streetwear",
      description: "Create an account and enjoy exclusive benefits at Mammoth Streetwear.",
    },
    "/place-order": {
      title: "Place Your Order - Mammoth Streetwear",
      description: "Complete your purchase and get your favorite streetwear delivered to your doorstep.",
    },
    "/orders": {
      title: "Your Orders - Mammoth Streetwear",
      description: "Track and manage your past and current orders easily.",
    },
    "/verify": {
      title: "Verify Your Account - Mammoth Streetwear",
      description: "Securely verify your Mammoth Streetwear account.",
    },
    "/reset-password": {
      title: "Reset Password - Mammoth Streetwear",
      description: "Reset your password securely and regain access to your account.",
    },
    "/privacy-policy": {
      title: "Privacy Policy - Mammoth Streetwear",
      description: "Understand how we handle and protect your personal data at Mammoth Streetwear.",
    },
    "/termandc": {
      title: "Terms & Conditions - Mammoth Streetwear",
      description: "Read our terms and conditions before shopping with Mammoth Streetwear.",
    },
    "/career": {
      title: "Join Our Team - Careers at Mammoth Streetwear",
      description: "Explore career opportunities at Mammoth Streetwear and be part of a dynamic fashion brand.",
    },
    "/return-exchange": {
      title: "Exchange & Return Policy - Mammoth Streetwear",
      description: "Learn about our return and exchange policy for a hassle-free shopping experience.",
    },
    "/sitemap": {
      title: "Sitemap - Mammoth Streetwear",
      description: "Find all our website pages in one place. Navigate easily through Mammoth Streetwear.",
    },
  };

  return (
    <HelmetProvider>
       
       <Helmet>
        <title>{pageSEO[currentPath]?.title || "Mammoth Streetwear - Shop Trendy & Premium Streetwear"}</title>
        <meta name="description" content={pageSEO[currentPath]?.description || "Discover the best in streetwear fashion."} />
        <meta name="keywords" content="streetwear, fashion, T-shirts, hoodies, premium wear, trendy outfits" />
        <meta property="og:title" content={pageSEO[currentPath]?.title || "Mammoth Streetwear"} />
        <meta property="og:description" content={pageSEO[currentPath]?.description || "Discover the best in streetwear fashion."} />
        <meta property="og:url" content={`${siteUrl}${currentPath}`} />
        <meta name="twitter:title" content={pageSEO[currentPath]?.title || "Mammoth Streetwear"} />
        <meta name="twitter:description" content={pageSEO[currentPath]?.description || "Discover the best in streetwear fashion."} />
        <link rel="canonical" href={`${siteUrl}${currentPath}`} />
      </Helmet>
       <ScrollRestoration />
          <ScrollManager />
    <div className="flex flex-col min-h-screen">
      {/* px-0.1 sm:px-[0.1vw] md:px-[0.1vw] lg:px-[0.1vw] */}
      <ToastContainer />
      <Layout>
      
        <Navbar />
        <SearchBar />
         <main className="flex-grow">
        <AnimatePresence mode={isBack ? "instant" : "wait"}>
        <Routes location={location} key={location.key}>
          
          <Route
              path="*"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Home />
                </motion.div>
              }
            />
          
        
          <Route
              path="/chat"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Chatbot />
                </motion.div>
              }
            />
           <Route
              path="/"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Home />
                </motion.div>
              }
            />
            <Route
              path="/collection"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Collection />
                </motion.div>
              }
            />
            <Route
              path="/about"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <About />
                </motion.div>
              }
            />
            <Route
              path="/contact"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Contact />
                </motion.div>
              }
            />
            <Route
              path="/product/:slug"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Product />
                </motion.div>
              }
            />
            {/* <Route
          path="/product/:productName"
          element={
            <motion.div
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={pageTransition}
            >
              <Product />
            </motion.div>
          }
        /> */}
            <Route
              path="/cart"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Cart />
                </motion.div>
              }
            />
            <Route
              path="/login"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Login />
                </motion.div>
              }
            />
            <Route
              path="/sitemap"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <SiteMap />
                </motion.div>
              }
            />
            <Route
              path="/place-order"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <PlaceOrder />
                </motion.div>
              }
            />
            <Route
              path="/orders"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Orders />
                </motion.div>
              }
            />
            <Route
              path="/verify"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Verify />
                </motion.div>
              }
            />
              {/* <Route
                path="/customize"
                element={
                  <motion.div
                    variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    transition={pageTransition}
                  >
                    <Customize />
                  </motion.div>
                }
              /> */}
            <Route
              path="/profile"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Profile />
                </motion.div>
              }
            />
             <Route
              path="/scratch"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Scratch/>
                </motion.div>
              }
            />
            <Route
              path="/reset-password"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <PasswordReset />
                </motion.div>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Privacypolicy />
                </motion.div>
              }
            />
            <Route
              path="/termandc"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <TermsAndConditions />
                </motion.div>
              }
            />
            <Route
              path="/career"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Career />
                </motion.div>
              }
            />
            <Route
              path="/return-exchange"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <ExchangeReturn />
                </motion.div>
              }
            />
            <Route
              path="/signup"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <SignUp />
                </motion.div>
              }
            />
            <Route
              path="/men"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Men/>
                </motion.div>
              }
            />
           
           
            <Route
              path="/kids"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Kids/>
                </motion.div>
              }
            />
         
           
            <Route 
              path="/women"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Women/>
                </motion.div>
              }
            />
            <Route 
              path="/oflinestore"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <Offilinestore/>
                </motion.div>
              }
            />
            <Route 
              path="/became-a-partnar"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={pageTransition}
                >
                  <BecameaPart/>
                </motion.div>
              }
            />
          </Routes>
          
         

        </AnimatePresence>
        </main>
        
      </Layout>
    </div>
    <Footer />
    <WhatsAppButton />
    </HelmetProvider>
  );
};

export default App;

